<template>
  <div data-sticky-container class="h-100">
    <base-card
      v-if="$vuetify.breakpoint.mdAndUp"
      class="sticky mb-5 d-flex flex-column justify-end"
      max-height="86vh"
    >
      <v-sheet style="overflow-y: auto" class="border-bottom">
        <ApartmentsList class="mx-1" />
      </v-sheet>
    </base-card>
  </div>
</template>

<script>
import ApartmentsList from "./ApartmentsList";
var Sticky = require("sticky-js");

export default {
  components: {
    ApartmentsList,
  },
  mounted() {
    new Sticky(".sticky", { stickyWrap: true, marginTop: 16, dataStickyFor: 959 /* mdAndUp */ });
  },
};
</script>

<style>
</style>
